import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { Box, Button, CssBaseline, Grid, ThemeProvider, Typography } from '@mui/material'

import PublicAppBar from '@/common/components/MainAppBar/PublicAppBar'
import { useToolBoxTreatments } from '@/common/hooks'
import { theme as lightTheme } from '@/common/themes/LightTheme'
import { StrikerThemeOverride } from '@/common/themes/overrides/StrikerThemeOverride'
import { WhitelabelThemeOverride } from '@/common/themes/overrides/WhitelabelThemeOverride'

const classes = {
    logoImgContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        width: '100%',
        marginBottom: 2,
    },
    logoImg: {
        height: 80,
    },
    notFoundImage: {
        width: '542px',
    },
    notFoundMessage: {
        gap: 1,
        mb: 3,
    },
}

const NotFound = () => {
    const { t } = useTranslation()
    const { showLibellulaWhitelabelling, showStrikerWhitelabelling } = useToolBoxTreatments()
    const navigate = useNavigate()

    const theme = useMemo(
        () =>
            showLibellulaWhitelabelling
                ? WhitelabelThemeOverride(lightTheme)
                : showStrikerWhitelabelling
                  ? StrikerThemeOverride(lightTheme)
                  : lightTheme,
        [showLibellulaWhitelabelling, showStrikerWhitelabelling]
    )

    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <PublicAppBar />
            <Grid
                component="section"
                flex={1}
                justifyContent="center"
                size={12}
                container
            >
                <Box
                    sx={[
                        {
                            alignItems: 'center',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            p: 12,
                        },
                        classes.root,
                    ]}
                >
                    <Box
                        alt="Not Found"
                        component="img"
                        src="404.svg"
                        sx={classes.notFoundImage}
                    />

                    <Box
                        sx={[
                            {
                                alignItems: 'center',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                            },
                            classes.notFoundMessage,
                        ]}
                    >
                        <Typography variant="h4">{t('Page not found')}</Typography>
                        <Typography variant="body1">{t("We can't find the page you're looking for.")}</Typography>
                    </Box>

                    <Button
                        color="primary"
                        size="large"
                        variant="contained"
                        onClick={() => navigate('/')}
                    >
                        Back to Home
                    </Button>
                </Box>
            </Grid>
        </ThemeProvider>
    )
}

export default NotFound
